/* PlayMix Diwali "kuch play, kuch mix": hero carousel autoplay + dots, category row arrows. */
(() => {
  document.querySelectorAll('[data-dk-carousel]').forEach((root) => {
    const track = root.querySelector('[data-dk-track]');
    const dots = [...root.querySelectorAll('[data-dk-dots] button')];
    const n = dots.length;
    let i = 0;
    let timer;
    const go = (k) => {
      i = (k + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    };
    const sync = () => {
      i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, k) => d.toggleAttribute('aria-current', k === i));
    };
    const play = () => {
      clearInterval(timer);
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => go(i + 1), 6000);
    };
    dots.forEach((d, k) => d.addEventListener('click', () => { go(k); play(); }));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    root.addEventListener('pointerenter', () => clearInterval(timer));
    root.addEventListener('pointerleave', play);
    track.addEventListener('touchstart', () => clearInterval(timer), { passive: true });
    play();
  });

  document.querySelectorAll('[data-dk-row]').forEach((root) => {
    const row = root.querySelector('[data-dk-rowtrack]');
    const step = () => (row.firstElementChild ? row.firstElementChild.getBoundingClientRect().width + 16 : 300) * 2;
    root.querySelector('[data-dk-prev]')?.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' }));
    root.querySelector('[data-dk-next]')?.addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' }));

    // progress bar: thumb width = visible share, position = scroll position
    const bar = root.querySelector('[data-dk-bar]');
    const paint = () => {
      if (!bar) return;
      const share = Math.min(1, row.clientWidth / row.scrollWidth);
      const max = row.scrollWidth - row.clientWidth;
      bar.style.width = `${share * 100}%`;
      bar.style.marginLeft = `${max > 0 ? (row.scrollLeft / max) * (1 - share) * 100 : 0}%`;
    };
    row.addEventListener('scroll', () => requestAnimationFrame(paint), { passive: true });
    addEventListener('resize', paint);
    paint();

    // one gentle peek the first time the row comes into view, so it reads as swipeable
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        if (row.scrollLeft === 0) row.classList.add('is-nudge');
      }, { threshold: 0.6 });
      io.observe(row);
      row.addEventListener('animationend', () => row.classList.remove('is-nudge'));
    }
  });
})();
